module.exports = __webpack_public_path__ + "assets/img/11_1100.f617536d.jpg";